export enum Bets {
  ONE = 1,
  TWO = 2,
}

export const BetIds = Object.values(Bets).filter((bet) => !isNaN(Number(bet))) as Bets[];
